<template>
<!-- 商品入库 -->
  <content-view>
    <div class="trade-stock">
      <a-form :form="form">
        <a-form-item label="扫描商品条形码" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input v-decorator="['goodsBarCode']"/>
        </a-form-item>
        <a-form-item label="商品编号" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input @blur="isNumExist" v-decorator="['serialNum', {rules: [{ required: true, message: '请输入商品编号'}]}]" placeholder="请输入"/>
        </a-form-item>
        <a-form-item label="商品名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input @blur="isNameExist" v-decorator="['name', {rules: [{ required: true, message: '请输入商品名称' }]}]" placeholder="请输入"/>
        </a-form-item>
        <a-form-item
          label="商品类别"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          style="position:relative"
        >
          <a-select
            v-decorator="['cateId', {rules: [{ required: true, message: '请选择商品类别' }]}]"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in typeOptions"
              :key="index"
            >{{item.name}}</a-select-option>
          </a-select>
          <span class="addNewType" @click="toAddType">新增类别</span>
        </a-form-item>
        <a-form-item label="商品规格" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input v-decorator="['specifica', {rules: [{ required: false, message: '请选择商品规格'}]}]" placeholder="请输入"/>
        </a-form-item>
        <a-form-item
          label="商品单位"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          style="position:relative"
        >
          <a-select
            v-decorator="['unitId', {rules: [{ required: true, message: '请选择单位' }]}]"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in goodsUnit"
              :key="index"
            >{{item.unit}}</a-select-option>
          </a-select>
          <span class="addNewType" @click="addUnitVisible = true">新增单位</span>
        </a-form-item>
        <a-form-item label="本次入库数（个）" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input-number :precision="0" style="width: 100%" :min="1" :step="1" placeholder="请输入" 
            v-decorator="['num', {rules: [{ required: true, message: '请输入本次入库数'}]}]"
          />
        </a-form-item>
        <a-form-item label="使用类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-radio-group v-decorator="['useType',{initialValue: 1}]">
            <a-radio :value="1">售卖</a-radio>
            <a-radio :value="2">自用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="商品成本价（个/元）" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input-number
            style="width: 100%"
            :min="0"
            :step="1"
            :precision="2"
            placeholder="请输入"
            v-decorator="['costPrice', {rules: [{ required: true, message: '请输入商品成本价'}]}]"
          />
        </a-form-item>
        <a-form-item label="商品售卖价（个/元）" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input-number
            style="width: 100%"
            :min="0"
            :step="1"
            :precision="2"
            placeholder="请输入"
            v-decorator="['sellPrice', {rules: [{ required: true, message: '请输入商品售卖价'}]}]"
          />
        </a-form-item>
        <a-form-item label="入库仓库" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input value="主仓库" disabled></a-input>
          <!-- <a-select
            v-decorator="['storeageId', {rules: [{ required: true, message: '请选择入库仓库'}]}]"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in wareHouseList"
              :key="index"
            >{{item.name}}</a-select-option>
          </a-select> -->
        </a-form-item>
        <div class="text-center">
          <a-button @click="$router.go(-1)">取消</a-button>
          <a-button type="primary" @click="handleSubmit" :loading="loading">确认</a-button>
        </div>
      </a-form>
      <a-modal title="新增类别" centered v-model="addNewTypeVisible" @ok="addNewTypes">
        <a-form :form="addNewTypeForm" @submit="addNewTypes">
          <a-form-item
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            label="类别名称"
            :validate-status="addTypeError"
            :help="helpTips"
          >
            <a-input id="error" v-decorator="['newType', {rules: [{ required: false}]}]"/>
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal title="新增单位" centered v-model="addUnitVisible" @ok="addGoodsUnit">
          商品单位： <a-input v-model="goodsUnitName" style="width: 70%" placeholder="请输入"/>
      </a-modal>
    </div>
  </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'food',
        components: {},
        props: {},
        data() {
            var typeOptions = [];
            return {
                form: this.$form.createForm(this),
                addNewTypeForm: this.$form.createForm(this),
                typeOptions,
                addNewTypeVisible: false,
                helpTips: '', //该类别已存在，不可新增
                addTypeError: '',
                goodsUnit: null,
                wareHouseList: [],
                goodsUnitName: '',
                addUnitVisible: false,
                loading: false,
                storeageId: '',
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            success() {
                this.$message.success('扫码成功，请填写商品信息');
            },
            warning() {
                this.$message.warning('扫描商品条形码');
            },
            handleSubmit() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.loading = true
                        this.$api.storage.goodsPut({ 
                            body: {
                                ...values,
                                shopId: this.shopId,
                                storeageId: this.storeageId
                            }
                        }).then(res => {
                            this.$message.success('操作成功');
                            this.$router.go(-1);
                            this.loading = false
                        }).catch(err => {
                            this.loading = false
                        })
                    }
                });
            },
            addNewTypes(e) {
                this.addNewTypeForm.validateFields((err, values) => {
                    if (!err) {
                        this.isExistsType(values);
                    }
                });
            },
            // 检查商品编号是否存在 存在返回true 否false
            isNumExist() {
                let values = {
                    warehouseId: this.storeageId,
                    serialNum: this.form.getFieldValue('serialNum'),
                }
                this.$api.storage.isNumExistGoods({ body: values }).then(res => {
                    if(res) {
                        this.$message.error('商品编号不能重复，请重新输入')
                    }
                });
            },
            // 检查商品名称是否存在 存在返回true 否false
            isNameExist() {
                let values = {
                    warehouseId: this.storeageId,
                    name: this.form.getFieldValue('name'),
                }
                this.$api.storage.isNameExist({ body: values }).then(res => {
                    if(res) {
                        this.$message.error('商品名称不能重复，请重新输入')
                    }
                });
            },
            addGoodsUnit() {
                this.$api.storage.addGoodsUnit({
                  body: {
                    unit: this.goodsUnitName
                  }
                }).then(res => {
                    this.goodsUnitList()
                    this.$message.success('操作成功')
                    this.goodsUnitName = ''
                    this.addUnitVisible = false
                });
            },
            toAddType() {
                this.addNewTypeVisible = true;
                this.addTypeError = '';
                this.helpTips = '';
                this.addNewTypeForm.resetFields();
            },
            resetForm() {
                this.form.resetFields();
                this.stockNumber = 1;
                this.tradePrice = 1;
                this.stockSales = 1;
            },
            //商品类别
            goodsCateList() {
                this.$api.storage.goodsCateList().then(res => {
                    this.typeOptions = res;
                });
            },
            //获取单位列表
            goodsUnitList() {
                this.$api.storage.goodsUnitList().then(res => {
                    this.goodsUnit = res;
                });
            },
            //获取仓库信息列表
            warehouseList() {
                if(!this.shopId) return
                this.$api.storage.warehouseList({ body: {
                    shopId: this.shopId,
                    pageNum: 1,
                    pageSize: 20
                } }).then(res => {
                    this.storeageId = res.data.filter(item => item.warehouseLevel == 1)[0].id;
                });
            },
            getWarehouseList() {
                if(!this.shopId) return
                this.$api.storage.getWarehouseList({params: {
                    shopId: this.shopId
                }}).then(res => {
                    this.wareHouseList = res;
                });
            },
            //判断类别
            isExistsType(params) {
                this.$api.storage
                .isExistsType({ params: { type: params.newType } })
                .then(res => {
                    if (res) {
                        this.helpTips = '该类别已存在，不可新增';
                        this.addTypeError = 'error';
                        return false;
                    } else {
                        this.helpTips = '';
                        this.addTypeError = '';
                        this.addNewTypeVisible = false;
                        this.goodsCateList();
                        return;
                    }
                });
            },
        },
        created() {},
        mounted() {
            this.warning();
            this.goodsCateList();
            this.goodsUnitList();
            this.getWarehouseList();
            this.warehouseList();
        },
        watch: {
            'shopId'() {
                this.getWarehouseList();
                this.warehouseList();
            }
        }
    };
</script>
<style lang="scss">
  .trade-stock {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
      padding-left: 50px;
      box-sizing: border-box;
      .addNewType {
          position: absolute;
          display: inline-block;
          width: 100%;
          cursor: pointer;
          text-decoration: 1px solid #f57f25;
          color: #f57f25;
          padding-left: 8px;
      }
  }
</style>